import { render } from "./PanelDownload.vue?vue&type=template&id=4e7a0481&scoped=true&ts=true"
import script from "./PanelDownload.vue?vue&type=script&lang=ts"
export * from "./PanelDownload.vue?vue&type=script&lang=ts"

import "./PanelDownload.vue?vue&type=style&index=0&id=4e7a0481&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e7a0481"]])

export default __exports__